
(function () {
  "use strict";

  function startShopAI() {
    const config = document.querySelector(
      "[data-ai-assistant-config]"
    );

    if (!config || document.querySelector(".shop-ai-root")) {
      return;
    }

    const root = document.createElement("div");
    root.className = "shop-ai-root";

    root.innerHTML = `
      <button class="shop-ai-launch" type="button">
        <span class="shop-ai-star">✦</span>
        Ask DR RASHEL AI
      </button>

      <section class="shop-ai-panel" hidden>
        <div class="shop-ai-header">
          <span class="shop-ai-mark">✦</span>
          <div class="shop-ai-heading">
            <strong>DR RASHEL AI</strong>
            <small>Skincare Shopping Assistant — Demo</small>
          </div>
          <button class="shop-ai-close" type="button"
            aria-label="Close chat">×</button>
        </div>

        <div class="shop-ai-messages" aria-live="polite">
        </div>

        <div class="shop-ai-chips">
          <button type="button" data-question="Dark spots">
            Dark Spots
          </button>
          <button type="button" data-question="Oily skin">
            Oily Skin
          </button>
          <button type="button" data-question="Dry skin">
            Dry Skin
          </button>
          <button type="button" data-question="Sunscreen">
            Sunscreen
          </button>
        </div>

        <form class="shop-ai-form">
          <input
            class="shop-ai-input"
            type="text"
            placeholder="Ask about skincare products..."
            maxlength="300"
            required
          >
          <button class="shop-ai-send" type="submit">
            Send
          </button>
        </form>

        <div class="shop-ai-footer">
          DR RASHEL Shopping Assistant • Preview
        </div>
      </section>
    `;

    document.body.appendChild(root);

    const launch = root.querySelector(".shop-ai-launch");
    const panel = root.querySelector(".shop-ai-panel");
    const close = root.querySelector(".shop-ai-close");
    const messages = root.querySelector(".shop-ai-messages");
    const form = root.querySelector(".shop-ai-form");
    const input = root.querySelector(".shop-ai-input");

    function addMessage(text, fromUser) {
      const item = document.createElement("div");
      item.className =
        "shop-ai-message " +
        (fromUser ? "shop-ai-user" : "shop-ai-bot");

      const bubble = document.createElement("div");
      bubble.className = "shop-ai-bubble";
      bubble.textContent = text;

      item.appendChild(bubble);
      messages.appendChild(item);
      messages.scrollTop = messages.scrollHeight;
    }

    addMessage(
      "Assalamualaikum! Welcome to DR RASHEL. " +
      "Aap kis type ke skincare products dhoond rahe hain? " +
      "Main abhi store ke matching products search kar sakta hoon.",
      false
    );

    launch.addEventListener("click", function () {
      panel.hidden = false;
      launch.setAttribute("aria-expanded", "true");
      input.focus();
    });

    close.addEventListener("click", function () {
      panel.hidden = true;
      launch.setAttribute("aria-expanded", "false");
    });

    function getSearchTerm(question) {
      const q = question.toLowerCase();

      if (/dark spot|pigment|daag/.test(q)) {
        return "vitamin c";
      }

      if (/oily|acne|pimple/.test(q)) {
        return "face wash";
      }

      if (/dry skin|moistur|khushk/.test(q)) {
        return "moisturizer";
      }

      if (/sun|spf/.test(q)) {
        return "sunscreen";
      }

      if (/serum/.test(q)) {
        return "serum";
      }

      if (/face wash/.test(q)) {
        return "face wash";
      }

      return question.trim().slice(0, 60);
    }

    async function askAssistant(question) {
      if (!question.trim()) return;

      addMessage(question, true);

      const term = getSearchTerm(question);

      addMessage(
        "Main aapke liye store mein matching products " +
        "search kar raha hoon...",
        false
      );

      const url = new URL(
        "/search/suggest.json",
        window.location.origin
      );

      url.searchParams.set("q", term);
      url.searchParams.set(
        "resources[type]",
        "product"
      );
      url.searchParams.set(
        "resources[limit]",
        "4"
      );

      try {
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error("Search unavailable");
        }

        const data = await response.json();

        const products =
          data.resources?.results?.products || [];

        if (!products.length) {
          addMessage(
            "Is search ke liye abhi koi matching " +
            "product nahi mila. Aap doosra keyword " +
            "try kar sakte hain.",
            false
          );
          return;
        }

        addMessage(
          "Ye aapke search se matching products hain. " +
          "Product details check karne ke liye " +
          "View Product par click karein.",
          false
        );

        const productList = document.createElement("div");
        productList.className = "shop-ai-products";

        products.forEach(function (product) {
          if (!product.url) return;

          const productURL = new URL(
            product.url,
            window.location.origin
          );

          if (productURL.origin !== window.location.origin) {
            return;
          }

          const card = document.createElement("div");
          card.className = "shop-ai-product";

          const details = document.createElement("div");
          details.className = "shop-ai-product-details";

          const title = document.createElement("strong");
          title.textContent = product.title;

          const actions = document.createElement("div");
          actions.className = "shop-ai-actions";

          const link = document.createElement("a");
          link.href = productURL.href;
          link.textContent = "View Product";

          actions.appendChild(link);
          details.appendChild(title);
          details.appendChild(actions);
          card.appendChild(details);
          productList.appendChild(card);
        });

        messages.appendChild(productList);
        messages.scrollTop = messages.scrollHeight;

      } catch (error) {
        addMessage(
          "Product search abhi available nahi hai. " +
          "Please website ke search option se try karein.",
          false
        );
      }
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      const question = input.value.trim();
      if (!question) return;

      input.value = "";
      askAssistant(question);
    });

    root.querySelectorAll("[data-question]").forEach(
      function (button) {
        button.addEventListener("click", function () {
          askAssistant(button.dataset.question);
        });
      }
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      startShopAI
    );
  } else {
    startShopAI();
  }
})();
